import { createContext } from 'react'

export type EditorLayout = 'desktop' | 'touch'
export const EditorLayoutContext = createContext<EditorLayout>('desktop')
